import { useTranslation } from 'next-i18next'

import DrillTopicElementsList from '~/components/Drill/DrillTopic/components/DrillTopicElemetsList'
import DrillTopicGridLayout from '~/components/Drill/DrillTopic/components/DrillTopicGridLayout'
import DrillTopicGridWrapper from '~/components/Drill/DrillTopic/components/DrillTopicGridWrapper'
import LianaDesktop from '~/components/Drill/DrillTopic/components/LianaDesktop'
import LianaMobile from '~/components/Drill/DrillTopic/components/LianaMobile'
import LianaTablet from '~/components/Drill/DrillTopic/components/LianaTablet'
import useGetGridPositionFunction from '~/components/Drill/hooks/useGetGridPositionFunction'
import { TopicData } from '~/types/theory'
import { processTopics } from '~/components/Drill/DrillTopic/helpers'

import { getGridPosition } from './Percent.grid'
import { getProperties } from './Percent.properties'

export default function Percent({
  topics,
  drillUrl,
}: {
  topics: TopicData[] | undefined
  drillUrl: string
}): React.ReactElement {
  const { t } = useTranslation(['drill'])
  const getGridPositionFunction = useGetGridPositionFunction(getGridPosition)
  const processedTopics = processTopics(topics, getGridPositionFunction, getProperties)

  const mobileGridRows = 'grid-rows-[repeat(34,70px)]'
  const tabletGridRows = 'md:grid-rows-[repeat(18,70px)]'
  const desktopGridRows = 'xl:grid-rows-[repeat(16,70px)]'

  return (
    <DrillTopicGridWrapper>
      <div className="md:hidden">
        <LianaMobile height={2600} />
      </div>
      <div className="hidden md:block xl:hidden">
        <LianaTablet
          image="math-drills/percent/beanstalk-tablet.png"
          imageAlt={t('drill:imageAlt.percentsBeanStalkDesktop')}
        />
      </div>
      <div className="hidden xl:block">
        <LianaDesktop
          classNames="-top-28 -left-16 w-[960px]"
          height={1382}
          image="math-drills/percent/beanstalk-desktop.png"
          imageAlt={t('drill:imageAlt.percentBeanStalkTablet')}
        />
      </div>
      <DrillTopicGridLayout className={[mobileGridRows, tabletGridRows, desktopGridRows].join(' ')}>
        <DrillTopicElementsList drillUrl={drillUrl} topics={processedTopics} />
      </DrillTopicGridLayout>
    </DrillTopicGridWrapper>
  )
}
